/**
 * #GR25 chat auto-scroll rules (pure, so they're unit-tested away from the DOM). The
 * standard chat behaviour: a new message auto-scrolls ONLY when the reader is already
 * near the bottom — never yank someone who scrolled up into history.
 */

/** Px slack for "near the bottom" — a reader within this of the end counts as at-bottom. */
export const NEAR_BOTTOM_PX = 80;

/** Is the scroller within NEAR_BOTTOM_PX of its end? */
export function nearBottom(
  m: { scrollHeight: number; scrollTop: number; clientHeight: number },
  slack = NEAR_BOTTOM_PX,
): boolean {
  return m.scrollHeight - m.scrollTop - m.clientHeight < slack;
}

/** Auto-scroll only on a new message (or the working bubble toggling) AND at-bottom. */
export function shouldAutoScroll(opts: { newMessage: boolean; busy: boolean; atBottom: boolean }): boolean {
  return (opts.newMessage || opts.busy) && opts.atBottom;
}
